import { VirtualManifestAPI } from '@wix/editor-platform-manifest-services';

export const checkContextMatch = (
  context: VirtualManifestAPI,
  callback: (context: VirtualManifestAPI) => boolean,
): boolean => {
  if (callback(context)) {
    return true;
  }

  return context
    .getChildren()
    .filter((child) => child.resolver.isElementEditable())
    .some((child) => checkContextMatch(child, callback));
};

export const isStyleValuePresent = (
  context: VirtualManifestAPI,
  allowedStyles: Set<string>,
) => {
  const styles = context.query.getStyles();
  const styleDefinitions = context.resolver.getStyleDefinitions();

  const isCssPropertiesIncludeValue = Object.entries(
    styles?.cssProperties ?? {},
  ).some(([styleType, value]) => {
    return allowedStyles.has(styleType) && value;
  });

  if (isCssPropertiesIncludeValue) {
    return true;
  }

  const isCssCustomPropertiesIncludeValue = Object.entries(
    styles?.cssCustomProperties ?? {},
  ).some(([styleId, value]) => {
    const cssPropertyType =
      styleDefinitions.cssCustomProperties[styleId]?.cssPropertyType;

    return cssPropertyType && allowedStyles.has(cssPropertyType) && value;
  });

  if (isCssCustomPropertiesIncludeValue) {
    return true;
  }

  return false;
};
